//
//
//
//
//
//
//
//
//

import _ from 'underscore'
export default {
  props: {
    pageNo: {
      default: 1
    },
    pageSize: {
      default: 20
    },
    total: {
      default: 0
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.$emit('update:pageNo', val)
      this.$emit('change')
    }
  }
}
